export const dateFormat = 'YYYY-MM-DD HH:mm:ss';
export const imagePrefix = (image: string) => {
  return `//b-convention.newscdn.cn/cybersecurity-week-2021/h5-image/${image}`
}